import React from 'react';
import ReactCountryFlag from 'react-country-flag';
import Localize from 'react-intl-universal';

import { get } from 'lodash-es';

import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

import { countryISOCodeByCountry } from '@common/Countries';

const StyledTypography = styled(Typography)(({ theme }) => ({
  paddingRight: '0.3rem',
  color: theme.palette.booking.header
}));

const StyledBox = styled(Box)(() => ({
  display: 'inline',
  paddingRight: '0.8rem'
}));

const LanguageAndFlag = ({ nativeLanguages, showLabel = true, containerSX }) => {
  return (
    <>
      <StyledBox sx={{ ...containerSX }}>
        {showLabel && (
          <Typography display='inline'>{Localize.get('Booking.language') + ': '}</Typography>
        )}
        <StyledTypography display='inline'>{get(nativeLanguages, '[0].value')}</StyledTypography>
        <ReactCountryFlag
          countryCode={countryISOCodeByCountry[get(nativeLanguages, '[0].key')?.toLowerCase()]}
          svg
          alt={get(nativeLanguages, '[0].value')}
          style={{
            width: '1.5em',
            height: '1em'
          }}
        />
      </StyledBox>
    </>
  );
};

export default LanguageAndFlag;
